export default __webpack_public_path__ + "static/media/crown.cbe7a03e.webp";